import controlDate from './index.js';

const SET_INVENTORIES = (state, inventories) => {
  state.inventories = inventories;
  state.outdated=false;
};

const INVALIDATE_INVENTORIES = (state, fetchedDeliveryTypes) => {
  state.outdated=true;
};

export default {
  SET_INVENTORIES,
  INVALIDATE_INVENTORIES,
};
